import { Component, Inject, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { HTTPService } from 'src/app/services/http.service';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { DateUtils } from 'src/app/system-utils/utils/DateUtils';
import { ObjectUtil } from 'src/app/system-utils/utils/ObjectUtil';

@Component({
    selector: 'products-download-task-processor',
    templateUrl: './products-download-task-processor.component.html',
    styleUrls: ['./products-download-task-processor.component.scss'],
    standalone: false
})
export class ProductsDownloadTaskProcessorComponent implements OnInit {

  constructor(@Inject(NZ_MODAL_DATA) public data, public dialogRef:NzModalRef<any>,
  private http:HTTPService,
  private ls:LanguageServices) { }
  value = 0;
  texto="";
  disabled = true;

  get percent(): number {
    return Math.min(100, Math.round(this.value));
  }

  ngOnInit(): void {
      let meliItens:Object[] = this.data;
      this.processarExecucao(meliItens);
  }

  async processarExecucao(meliItens: Object[]) {
    // 100 dividido pelo total de itens (antes dividia por length-1, estourando 100%)
    const filePercent = meliItens.length > 0 ? 100 / meliItens.length : 100;
    let i = 1;

      for ( var data of meliItens ){

          await this.createProduct(data).then(main=>{
            this.texto = this.texto +DateUtils.getNow() + ' ' + this.ls.instant('productsdownload.processor.success') + ': '+ data['ID'] + " - " + data['DESCRPROD']+"\n";
            this.value =filePercent*i;
            i++;

          }).catch(re=>{
            this.value =filePercent*i;
            i++;
          });
      }




    this.disabled = false;
  }

  sair(){
    this.dialogRef.close(null);
  }


  createProduct(meliItem:Object){

    return  new Promise((resolve,reject)=>{

      this.texto = this.texto + DateUtils.getNow() + " - " + this.ls.instant('productsdownload.processor.started') + ": "+ meliItem['ID']+"\n";

      let ob = {
        codeCompany :meliItem['CODECOMPANY'],
        method: 'GET',
        serviceName: 'GetItem',
      }

      ob['params'] = [{key:'@MLB', value: meliItem['ID']}];

      this.http.post(ob,'MeliNotifications/getGenericMeli',false,true,false).subscribe(result=>{
          let resultado = result['resultado'];
          let obdesc = {
            codeCompany : meliItem['CODECOMPANY'],
            method: 'GET',
            serviceName: 'GetItemDesc',
          }

          obdesc['params'] = [{key:'@MLB', value: meliItem['ID']}];

          this.http.post(obdesc,'MeliNotifications/getGenericMeli',false,true,false).subscribe(result=>{
            let desc = result['resultado'];
            resultado['description'] = desc['plain_text'];

            let pro = {
              codeCompany:  meliItem['CODECOMPANY'],
              codeProduct: meliItem['CODEPRODUCT'],
              codeContract: meliItem['CODECONTRACT'],
              data: resultado,
              type:"update"
            }

            pro['CODEMELI'] = meliItem['CODEMELI'];

            this.http.post(pro, 'MeliNotifications/createProduct',false,true,false).subscribe(c=>{
                //this.texto = this.texto + 'Produto relacionado com sucesso.'+'\n';
                resolve("sucesso");

            },
            error=>{
              this.texto = this.texto + DateUtils.getNow() + " - " +this.getError(error) + '\n';
              reject();
            })
          },
          error=>{
            this.texto = this.texto + DateUtils.getNow() + " - " +this.getError(error) + '\n';
            reject();
          });
      },
      error=>{
        this.texto = this.texto + DateUtils.getNow() + " - " +this.getError(error) + '\n';
        reject();
      });

    });

  }


  getError(error):string{

    if ( ObjectUtil.isNotEmpty(error.error)){
      if ( ObjectUtil.isNotEmpty(error.error.message)){
        return error.error.message;
      }
    }
    if ( ObjectUtil.isNotEmpty(error)){
      if ( ObjectUtil.isNotEmpty(error.message)){
        return error.message;
      }
    }

      return this.ls.instant('productsdownload.processor.noErrorMessage');
  }

}
